import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { Section, Eyebrow, Heading } from '../Section';
import { CTAButton } from '../CTAButton';
import { faqs } from '../../data/content';
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return <Section dark data-id="element-128" data-mp="122dcx9d3pxct">
      <Eyebrow data-id="element-129" data-mp="123ocsy3fekyn">Frequently asked questions</Eyebrow>
      <Heading data-id="element-130" data-mp="124g8sa0xqkpg">Everything you might be wondering</Heading>

      <ul className="mt-8 space-y-2.5" data-id="element-131" data-mp="1ptip9eju27id">
        {faqs.map((f, i) => {
        const isOpen = open === i;
        return <li key={f.q} className="overflow-hidden rounded-xl border border-ink-500 bg-ink-700" data-id="element-132" data-mp="1utde7ck1sn0s" data-mpi={i}>
              <h3 data-id="element-133" data-mp="1g0bknvwx2vjc">
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-3 px-4 py-4 text-left transition-colors duration-150 ease-out hover:bg-ink-600 focus-visible:outline focus-visible:outline-2 focus-visible:-outline-offset-2 focus-visible:outline-spark" data-id="element-134" data-mp="1l1hejx2bcoug">
                  <span className="text-[15px] font-semibold leading-snug text-white" data-id="element-135" data-mp="2js72jjidnfr9">{f.q}</span>
                  <ChevronDownIcon className={`h-5 w-5 shrink-0 text-flame-400 transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-136" data-mp="2yh3ie2qodx2f" />
                </button>
              </h3>
              {isOpen ? <p className="animate-popIn border-t border-ink-500 px-4 py-4 text-[14px] leading-relaxed text-zinc-300" data-id="element-137" data-mp="32jzurbpmgwxx">
                  {f.a}
                </p> : null}
            </li>;
      })}
      </ul>

      <div className="mt-8" data-id="element-138" data-mp="1n0d8a8j4sl3j">
        <CTAButton data-id="element-139" data-mp="1n1oc28cktsun" />
      </div>
    </Section>;
}